import { createContext, useContext } from 'react';

// Contexto de rol RRHH (ADENDA 1 v49a). Hermano de AdminContext, NO lo reemplaza.
// Independiente de admin: pertenecer al grupo de administradores NO otorga RRHH.
// App.js provee el value desde los claims de grupo; RequireRRHH y los módulos de
// RRHH (v49) lo consumen via useRRHH(). Falla en seguro: false si no hay GUID.
export const RRHHContext = createContext(false);
export const useRRHH = () => useContext(RRHHContext);
